import { Link } from 'react-router-dom';
import { MapPin, Phone, Clock, CreditCard, Banknote, Smartphone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_butt-karahi-luton/artifacts/dwb7qv2j_kqaK9%20%281%29.jpg";

const TikTokIcon = () => (
  <svg 
    viewBox="0 0 24 24" 
    width="20" 
    height="20" 
    fill="currentColor"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-black text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img 
              src={LOGO_URL} 
              alt="Butt Karahi Luton" 
              className="h-20 w-auto object-contain mb-6 bg-white p-2"
            />
            <p className="text-white/70 text-sm leading-relaxed">
              Authentic Pakistani cuisine with traditional recipes and a contemporary twist. 
              Experience the taste of excellence.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-xl font-semibold text-brand-red mb-6">Quick Links</h3>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="text-white/70 hover:text-brand-red transition-colors text-sm">Home</Link>
              <Link to="/menu" className="text-white/70 hover:text-brand-red transition-colors text-sm">Our Menu</Link>
              <Link to="/about" className="text-white/70 hover:text-brand-red transition-colors text-sm">About Us</Link>
              <Link to="/contact" className="text-white/70 hover:text-brand-red transition-colors text-sm">Contact</Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-serif text-xl font-semibold text-brand-red mb-6">Contact Info</h3>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <MapPin className="text-brand-red mt-1 flex-shrink-0" size={18} />
                <p className="text-white/70 text-sm">4 Cumberland Street,<br />Luton LU1 3BW</p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="text-brand-red flex-shrink-0" size={18} />
                <a href="tel:01582517786" className="text-white/70 hover:text-brand-red transition-colors text-sm">
                  01582 517786
                </a>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="text-brand-red mt-1 flex-shrink-0" size={18} />
                <p className="text-white/70 text-sm">Open Daily<br />1PM - 11:30PM</p>
              </div>
            </div>
          </div>

          {/* Payment & Social */}
          <div>
            <h3 className="font-serif text-xl font-semibold text-brand-red mb-6">Payment Methods</h3>
            <div className="flex flex-wrap gap-4 mb-8">
              <div className="flex items-center gap-2 text-white/70 text-sm">
                <Banknote size={18} className="text-brand-red" />
                <span>Cash</span>
              </div>
              <div className="flex items-center gap-2 text-white/70 text-sm">
                <CreditCard size={18} className="text-brand-red" />
                <span>Cards</span>
              </div>
              <div className="flex items-center gap-2 text-white/70 text-sm">
                <Smartphone size={18} className="text-brand-red" />
                <span>Contactless</span>
              </div>
            </div>

            <h3 className="font-serif text-xl font-semibold text-brand-red mb-4">Follow Us</h3>
            <div className="flex gap-4">
              <a 
                href="https://www.tiktok.com/@buttkarahiluton"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="tiktok-link"
                className="w-10 h-10 flex items-center justify-center border border-brand-red text-brand-red hover:bg-brand-red hover:text-white transition-all duration-300"
                aria-label="Follow us on TikTok"
              >
                <TikTokIcon />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-white/50">
            <p>© {new Date().getFullYear()} Butt Karahi Luton. All rights reserved.</p>
            <span className="hidden md:inline text-white/30">|</span>
            <p>
              Created by{' '}
              <a 
                href="https://www.wktechexpert.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-brand-red hover:text-red-400 transition-colors"
                data-testid="creator-link"
              >
                wktechexpert.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
